export default "__VITE_ASSET__4f362121__"